/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Api_DescInputs */

const en_mk_team_api_desc = /** @type {(inputs: Mk_Team_Api_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your AI connection for coding in the cloud or on your computer. Your selected provider bills AI usage.`)
};

const id_mk_team_api_desc = /** @type {(inputs: Mk_Team_Api_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan koneksi AI milikmu untuk coding di cloud atau komputer sendiri. Penyedia yang kamu pilih menagihkan pemakaian AI.`)
};

/**
* | output |
* | --- |
* | "Add your AI connection for coding in the cloud or on your computer. Your selected provider bills AI usage." |
*
* @param {Mk_Team_Api_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_api_desc = /** @type {((inputs?: Mk_Team_Api_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Api_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_api_desc(inputs)
	return en_mk_team_api_desc(inputs)
});